import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

// Ensure English is set immediately on page load
try {
  // Set HTML lang attribute to English immediately
  document.documentElement.lang = 'en';
  
  // For first-time visitors, ensure English is the default
  const hasUserPreference = localStorage.getItem('user-language-preference');
  if (!hasUserPreference) {
    localStorage.setItem('website-language', 'en');
  }
} catch (error) {
  console.warn('Failed to set initial language');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
